import { BrowserId } from 'Browser/BrowserId';
import { User } from 'Browser/User';
import { Environment } from 'Common/Environment';
import { SiteBasics } from 'Common/SiteBasics';
import { Urls } from 'Common/Urls';
import { ConnectionToServer, IRoot } from 'Shared/Root';
import {createContext,useContext} from 'solid-js';

interface ISiteProvider extends IRoot {
	children;
	user: User;
	setUser: (user:User) => void;
}

const SiteContext = createContext();

export function SiteProvider(P:ISiteProvider)
{
	return (
		<SiteContext.Provider value={P}>
			{P.children}
		</SiteContext.Provider>
	);
}

export function useBuild():Environment
{
	return (useContext(SiteContext) as ISiteProvider).build;
}

export function useSite():SiteBasics<BrowserId>
{
	return (useContext(SiteContext) as ISiteProvider).site;
}

export function useUser():User
{
	return (useContext(SiteContext) as ISiteProvider).user;
}

export function useServer():ConnectionToServer
{
	return (useContext(SiteContext) as ISiteProvider).server;
}

